export enum ServiceTypeEnum {
    Mortgage = 1,
    Financial = 2,
    Investment = 3,
    Pension = 4,
    Protection = 5,
    Business = 6,
    Existing = 7
}